type TooltipPayloadEntry = {
    dataKey: string
    name: string
    value: number | string
    color: string
  }
  
  type Props = {
    active?: boolean
    payload?: TooltipPayloadEntry[]
    label?: string | number
  }
  
  export default function ChartTooltip({ active, payload, label }: Props) {
    if (!active || !payload?.length) return null
    return (
      <div
        style={{
          background: 'var(--bg-2)',
          border: '0.5px solid var(--bd-1)',
          borderRadius: 'var(--radius)',
          padding: '8px 10px',
          fontSize: 10,
        }}
      >
        <div style={{ color: 'var(--t-1)', marginBottom: 4, fontWeight: 500 }}>{label}</div>
        {payload.map((p) => (
          <div
            key={p.dataKey}
            style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}
          >
            <span style={{ color: p.color }}>{p.name}</span>
            <span style={{ color: 'var(--t-0)', fontWeight: 500 }}>{p.value}</span>
          </div>
        ))}
      </div>
    )
  }